import React from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'
import { WORLDWIDE_SEARCH_LOCATION_NAME } from '@/domain/filterOptions/constants'

const SearchRefinement = (props) => {
  const { text, refinement, refine, className } = props
  return (
    <span
      className={className}
      onClick={() => refine(refinement)}
    >
      {text}
    </span>
  )
}
const ConnectedSearchRefinement = connectRefinementList(SearchRefinement)

const WorldwideSearchRefinement = ({
  userCountryCode,
  className,
  ...props
}) => {
  const text = WORLDWIDE_SEARCH_LOCATION_NAME

  if (!userCountryCode) {
    return (
      <a
        className={className}
        href="/browse/"
      >
        {text}
      </a>
    )
  }

  const refinement = []
  const classNameWithHover = className + ' hover:cursor-pointer'
  const connectedSearchRefinementProps = {
    ...props,
    attribute: 'locations',
    label: 'Locations',
    operator: 'and',
    text,
    refinement,
    className: classNameWithHover
  }
  return <ConnectedSearchRefinement {...connectedSearchRefinementProps} />
}

export default WorldwideSearchRefinement
